import { render, staticRenderFns } from "./QuickPhrases.vue?vue&type=template&id=2c903c2f&scoped=true&"
import script from "./QuickPhrases.vue?vue&type=script&lang=js&"
export * from "./QuickPhrases.vue?vue&type=script&lang=js&"
import style0 from "./QuickPhrases.vue?vue&type=style&index=0&id=2c903c2f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c903c2f",
  null
  
)

export default component.exports